import { Paper } from '@mantine/core';
import { Route, Switch } from 'wouter';
import OfferHubPage from './OfferHubPage';
import OfferListPage from './OfferListPage';

export default function OffersPage() {
  return (
    <Paper p="md" h="100%">
      <Switch>
        <Route path="/:id/:tab?" component={OfferHubPage} />
        <Route path="/" component={OfferListPage} />
      </Switch>
    </Paper>
  );
}
